import React, { useState, useEffect } from 'react';
import { TfiClose } from "react-icons/tfi";
import { FaLinkedin, FaSkype, FaGithub } from "react-icons/fa";
import { Link as ScrollLink, Element, Events, scrollSpy } from 'react-scroll';
import '../style.css';
import Contact from './Contact';
import About from './About';
import Home from './Home';
import Service from './Service';

const Content = ({ setStart }) => {
  const [activeLink, setActiveLink] = useState('HOME');

  useEffect(() => {
    Events.scrollEvent.register('begin', function () {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register('end', function () {
      console.log("end", arguments);
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  const handleSetActive = (to) => {
    setActiveLink(to.toUpperCase());
  };

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="h-screen flex flex-col justify-between">

      {/* Navbar */}
      <div className="fixed top-0 start-0 flex justify-between items-center w-screen px-6 pt-2">
        <div className="flex flex-col items-start text-start">

          <ScrollLink
            to="home"
            smooth={true}
            duration={500}
            className={`nav-link px-1 ${activeLink === 'HOME' ? 'active' : ''}`}
            onClick={() => handleSetActive('home')}
            spy={true}
            onSetActive={handleSetActive}
          >
            HOME
          </ScrollLink>

          <ScrollLink
            to="service"
            smooth={true}
            duration={500}
            className={`nav-link px-1 ${activeLink === 'SERVICE' ? 'active' : ''}`}
            onClick={() => handleSetActive('service')}
            spy={true}
            onSetActive={handleSetActive}
          >
            SERVICE
          </ScrollLink>
         

          <ScrollLink
            to="about"
            smooth={true}
            duration={500}
            className={`nav-link px-1 ${activeLink === 'ABOUT' ? 'active' : ''}`}
            onClick={() => handleSetActive('about')}
            spy={true}
            onSetActive={handleSetActive}
          >
            ABOUT
          </ScrollLink>

          <ScrollLink
            to="contact"
            smooth={true}
            duration={500}
            className={`nav-link px-1 ${activeLink === 'CONTACT' ? 'active' : ''}`}
            onClick={() => handleSetActive('contact')}
            spy={true}
            onSetActive={handleSetActive}
          >
            CONTACT
          </ScrollLink>
         
        </div>

        <button className="btn-close" onClick={() => setStart(false)}>
          <TfiClose size={34} className='text-white'/>
        </button>
      </div>

      {/* Sections */}
      <Element name="home" className="section">
        <div className='home'>
          <Home />
        </div>
      </Element>
      <Element name="service" className="section">
        <div className='service'>
          <Service />
        </div>
      </Element>
      <Element name="about" className="section">
        <div className='about'>
          <About />
        </div>
      </Element>
      <Element name="contact" className="section">
        <div className='contact'>
          <Contact />
        </div>
      </Element>

      {/* Footer */}
      <div className="flex justify-center mb-10">
        <FaLinkedin
          size={34}
          className="social-media mx-2 mb-4"
          onClick={() => openLink('https://www.linkedin.com/in/karthi-srinivasan-92660923b/')}
        />
        <FaGithub
          size={34}
          className="social-media mx-2 mb-4"
          onClick={() => openLink('https://github.com/karthi2002')}
        />
        <FaSkype
          size={34}
          className="social-media mx-2 mb-4"
          onClick={() => openLink('https://join.skype.com/invite/wlPQ3YJsl2tO')}
        />
      </div>
    </div>
  );
}

export default Content;
